import type { FC } from 'react';

import { getTitleIcon } from '../../utils';
import type { WorkProject } from '../../types';

interface ScopeSectionProps {
  project: WorkProject;
}

const ScopeSection: FC<ScopeSectionProps> = ({ project }) => (
  <section className="font-montreal text-zinc-800 dark:text-white/80">
    <div className="mx-auto w-full max-w-[96rem] px-6 sm:px-10 lg:px-16">
      <header className="flex items-center justify-between pb-8">
        <h3 className="text-3xl font-light tracking-tight text-zinc-900 md:text-[2.75rem] dark:text-white">
          Scope of work
        </h3>
        <span className="text-base text-zinc-500 dark:text-white/40">Services</span>
      </header>

      <div className="grid md:grid-cols-2">
        {project.scope.map((item, index) => {
          const borders = [
            index >= 2 ? 'md:border-t' : '',
            index % 2 === 1 ? 'md:border-l md:border-t' : '',
          ]
            .filter(Boolean)
            .join(' ');
          const TitleIcon = getTitleIcon(item.title);

          return (
            <article
              key={item.title}
              className={`grid grid-rows-[auto_minmax(0,1fr)] border border-zinc-100 ${borders} dark:border-white/15`}
            >
              <div className="flex items-center justify-between border-b border-zinc-100 px-8 py-6 md:px-12 dark:border-white/15">
                <div className="flex items-center gap-2.5 text-zinc-900 dark:text-white">
                  <TitleIcon aria-hidden="true" className="size-5 text-zinc-500 dark:text-white/55" />
                  <h4 className="text-[1.25rem] font-light tracking-tight md:text-[1.5rem]">{item.title}</h4>
                </div>
                <span className="text-base text-zinc-400 dark:text-white/30">{`${index + 1}`.padStart(2, '0')}</span>
              </div>

              <div className="flex min-h-[14rem] items-end px-8 pb-10 pt-8 md:px-12 md:pb-12 md:pt-10">
                <p className="max-w-[36ch] text-base leading-relaxed text-zinc-700 md:text-lg dark:text-white/70">
                  {item.description}
                </p>
              </div>
            </article>
          );
        })}
      </div>
    </div>
  </section>
);

export default ScopeSection;
